 <template>

	<section class="organizations-table">

		<div style="padding: 10px 2px;">

			<base-combobox
				:service="$options.firmService"
				fetch-func="firmFirm"
				:fetch-params="{
					parent_id: $store.state.Auth.user.firmId,
					archived: organizationArchived,
					includes: 'firm,firm.ratings,firm.permissions,tags,roles'
				}"
				:value.sync="firmName"
				label-key="firm.name"
				:open-on-focus="false"
				hide-options
				:fetch-on-init="false"
				:per-scroll="100000"
				ref="comboboxFirms"
			>
				<template #control>

					<p class="control">

						<button class="button is-link" :disabled="!firmName" @click.prevent="() => add()">ADD</button>

					</p>

				</template>
			
			</base-combobox>
			
		</div>

		<div class="base-table ">

			<div class="b-table">

				<div class="table-wrapper">

					<div style="padding:0px 10px 10px;">
						<input type="checkbox" v-model="includeArchived"> Include Archived
					</div>

					<table :class="'table is-bordered is-hoverable b-table has-background-light' + (loading ? ' is-loading' : '')">

						<tbody v-if="firmsFiltered.length">

							<tr v-for="firm in firmsFiltered" :key="firm.firm.id" 

							@click="clickFirm(firm)"

							:class="organization && organization.id == firm.firm.id ? 'active-firm' : ''">

								<td class="has-font-weight-bold no-wrap">

									<template v-if="firm.notAssociated">

										<span class="has-text-grey">{{ firm.firm.name }}</span>

									</template>

									<template v-else-if="firm.archived_at == null">

										<span>{{ firm.firm.name }}</span>
											
									</template>

									<template v-else>
										
										<strike>{{ firm.firm.name }}</strike>

									</template>
								</td>
							</tr>

						</tbody>

						<tbody v-else>
							
							<tr>
							
								<td>No results found</td>
							
							</tr>

						</tbody>

					</table>
				
				</div>

			</div>

		</div>

	</section>

</template>

<script>

	import { FirmService } from "@/services/firm.service";

	import { AssociatedService } from "@/services/associated.service";

	import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

	import BaseCombobox from "@/components/partials/BaseCombobox";

	export default {
	
	firmService: AssociatedService,

	props: ['organization', 'organizations', 'organizationArchived', 'selectedFirm'],

	components: {
		BaseCombobox
	},

    data() {

        return {
        	includeArchived: false,

    		archived: true,

    		// organizations: [],

    		firm_firm: [],

    		organizationDefault: true,

    		firmDefault: true,

    		allFirm: [],

    		firmName: '',

    		loading: false,

			// This should be organizations but have issues with name duplicates
			firms: [],

			firmsAll: [],
        }

    },

    computed: {

		notAssociated() {

			return this.allFirm.filter(element => this.firm_firm.every(firm => firm.child_id != element.id));

		},

		filterNotAssociated() {

			return this.notAssociated.filter(element => element.name.toLowerCase().includes(this.firmName.toLowerCase()));

		},

		canManageFirm() {

			return this.$store.getters["Auth/hasPermission"]("can manage firms")
			return false;

		},


		sortedFirmFirm() {

			let active = this.firm_firm.filter(element => element.archived_at == null);

			active = this.sortFirm(active);

			let archived = this.firm_firm.filter(element => element.archived_at != null);

			archived = this.sortFirm(archived);

			return active.concat(archived);

		},

		firmsCombined() {
			return this.firmsAll.reduce((acc, firm) => {
				let found = null;
				let option = firm;

				// Replace firmsAll data with firms data
				if (found = this.firms.find(
					firm_ => firm_.firm.id === firm.firm.id
				)) {
					option = found;
				}

				acc.push(option);

				return acc;
			}, []);
		},

		firmsFiltered() {
			// if (this.firmName) {
			// 	return this.firmsCombined.filter(firm =>
			// 		firm.firm.name
			// 			.toString()
			// 			.toLowerCase()
			// 			.indexOf(this.firmName.toLowerCase()) >= 0
			// 	);
			// }
			// return this.firms;

			if (this.includeArchived) {
				if (this.firmName) {
					let data = this.firmsCombined.filter(firm =>
						firm.firm.name
							.toString()
							.toLowerCase()
							.indexOf(this.firmName.toLowerCase()) >= 0
					);
					// console.log(data);
					return data;
				}
				return this.firms;
			} else {
				if (this.firmName) {
					let data = this.firmsCombined.filter(firm => {

						let archived = firm.archived_at;
						let keyExist = firm.firm.name.toString().toLowerCase().indexOf(this.firmName.toLowerCase()) >= 0

						return !archived && keyExist;

						// firm.firm.archived_at == null &&
						// firm.firm.name
						// 	.toString()
						// 	.toLowerCase()
						// 	.indexOf(this.firmName.toLowerCase()) >= 0
					});
					// console.log(data);
					return data;
				}
				return this.firms.filter(firm => firm.archived_at == null);
			}

		}
    },

    watch: {

    	organizationArchived() {

			this.$nextTick(() => {
				// this.fetch();
				this.fetchFirm();
			})

    	},

    	organizations() {

    		// if (! this.organization) {
				// this.defaultOrganization();
    		// }

    	},

    	firm_firm(value, oldvalue) {

			if (!oldvalue.length) {
				// this.defaultFirm();
			}

    	},

    },

    methods: {

		sortFirm(firms) {

			const sortFirms = firms;

			return sortFirms.sort((a, b) => {

				var x = a.firm_name.toLowerCase(), y = b.firm_name.toLowerCase();

				return x < y ? -1 : x > y ? 1 : 0;

			});

		},

		async fetch() {
			return;

			await FirmService.getAll({ includes: 'ratings,ratings.createdBy,managedBy', archived: true }).then(response => {

				let data = JsonDenormalizer.denormalize(response);

				this.$emit('update:organizations', data);

				this.allFirm = data;

				// this.organizations = JsonDenormalizer.denormalize(response);

				this.$nextTick(() => {

					if (this.organizations.length && this.organizationDefault) {

						this.defaultOrganization();

						this.organizationDefault = false;

					}

				})

			});

		},

		// async fetchAll() {

		// 	await FirmService.getAll({archived: true}).then(response => {

		// 		this.allFirm = JsonDenormalizer.denormalize(response);

		// 	});

		// },

		fetchFirmsAll() {
			return FirmService.getAll({ archived: true }).then(response => {
				const options = JsonDenormalizer.denormalize(response);
				// Format so that it will look like combobox options (firm firm transformed)
				return options.map(option => {
					return {
						firm: option,
						// This will be used in combobox option list formatting
						notAssociated: true
					}
				});
			});
		},

    	async fetchFirm() {
			// Fetches all firms (used as combobox search options) and associated firms (displayed as combobox default options)
			const response = await Promise.all([
				this.fetchFirmsAll(),
				this.$refs.comboboxFirms.fetchOptions(1, false)
			]);

			this.firms = response[1];
			this.firmsAll = response[0];

			return;

    		this.loading = true;

			await AssociatedService.firmFirm({parent_id: this.$store.state.Auth.user.firmId, archived: this.organizationArchived}).then(response => {

				this.firm_firm = response;

				this.$nextTick(() => {

					if (this.firm_firm.length && this.firmDefault) {

						this.firmDefault = false;

						this.defaultFirm();

					}

	    			this.loading = false;
				
				})


			 });

       	},

		defaultOrganization() {

			this.$emit('update:organization', this.organizations.find(element => element.id == this.$store.state.Auth.user.firmId))

		},


		defaultFirm() {

			this.$emit('update:selectedFirm', this.firm_firm.find(element => element.child_id == this.$store.state.Auth.user.firmId))

		},

		clickFirm(firm) {
			// let clickedFirm = this.organizations.find(element => element.id == firm.child_id);
			if (firm.notAssociated) {
				this.add(firm.firm.name);
			}else{
				this.$emit('update:organization', firm.firm);
				this.$emit('update:selectedFirm', firm);
			}
		},

		add(keyword = null) {

			// console.log()

			if (this.canManageFirm) {

				FirmService.attachOrCreate({firm_id: this.$store.state.Auth.user.firmId, keyword: keyword || this.firmName}).then(response => {

					this.fetch();

					this.fetchFirm();

					this.firmName = '';

					let firm = this.allFirm.find(element => element.name.toLowerCase() == this.firmName.toLowerCase());

					if (firm) {

                		this.allFirm.splice(this.allFirm.findIndex(element => element.id == firm.id), 1);

					}

				});

			}

		},

		reset() {

			this.organizationDefault = true;

    		this.firmDefault = true;

			this.fetch();

			this.fetchFirm();

		},

	    async archive(type, id) {

	        this.archiving = true;

	        AssociatedService.archive({id: id}).then(response => {

	            this.$buefy.toast.open({
	        
	                message: type == 'archive' ? 'Associated Organization has been archived.' : 'Associated Organization has been restored.',
	            
	                type: "is-info",
	            
	                position: "is-top-right"
	        
	            });

				this.fetchFirm();
            	// this.$refs.comboboxFirms.fetchOptions(1, false);

	        });

	        this.archiving = false;

	    },

    },

    async mounted() {
		this.fetch();
		await this.fetchFirm();
		// Set default selected firm
		const organization = this.firms.find(element => element.child_id == this.$store.state.Auth.user.firmId);
		this.$emit('update:selectedFirm', organization);
		this.$emit('update:organization', organization.firm);
        this.$refs.comboboxFirms.focus();
		// this.fetchAll();

    }

};

</script>

<style scoped>

.table td{
	cursor: pointer;
	padding: 10px;
}

.active-firm {
	background-color: #3273dc;
}

.active-firm td{

	color: white !important;

}

.active-firm td:hover{

	background-color: #3273dc;

}

.not-active-firm td{

	padding: 10px 10px;

}



</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizations.vue